export default __webpack_public_path__ + "static/title-gallery-zh-Hans-c19f01cc4afe78922717196eea521f9c.png";